import {
  REQUEST_ADD_REACTION, FAIL_ADD_REACTION, SUCCESS_ADD_REACTION,
  REQUEST_REMOVE_REACTION, FAIL_REMOVE_REACTION, SUCCESS_REMOVE_REACTION,
} from 'shared/actionTypes';

function pendingReactions(state = [], action) {
  const { reaction } = action.payload;

  switch (action.type) {
  case REQUEST_ADD_REACTION:
  case REQUEST_REMOVE_REACTION:
    return [...state, reaction];
  case FAIL_ADD_REACTION:
  case SUCCESS_ADD_REACTION:
  case FAIL_REMOVE_REACTION:
  case SUCCESS_REMOVE_REACTION:
    const reactionIndex = state.lastIndexOf(reaction);
    if (reactionIndex === -1) {
      return state;
    }

    return [
      ...state.slice(0, reactionIndex),
      ...state.slice(reactionIndex + 1),
    ];
  default:
    return state;
  }
}

export default function pendingContentReactions(state = {}, action) {
  switch (action.type) {
  case REQUEST_ADD_REACTION:
  case REQUEST_REMOVE_REACTION:
  case FAIL_ADD_REACTION:
  case SUCCESS_ADD_REACTION:
  case FAIL_REMOVE_REACTION:
  case SUCCESS_REMOVE_REACTION:
    const { communityContentRelatedId, communityContentType } = action.payload;
    const communityContentIdKey = `${communityContentType}-${communityContentRelatedId}`;
    return Object.assign({}, state, {
      [communityContentIdKey]: pendingReactions(state[communityContentIdKey], action),
    });
  default:
    return state;
  }
}
